export class PositionData {
  private id: number
  private code: string
  private description: string
  private storage: string

  constructor(id: number, code: string, description: string, storage: string) {
    this.id = id
    this.code = code
    this.description = description
    this.storage = storage
  }
}

export class Position {
  public success: boolean
  public message: string
  public data?: PositionData[]

  constructor(success: boolean, message: string, data?: PositionData[]) {
    this.success = success
    this.message = message
    this.data = data
  }
}

export class PositionDataDnet {
  private id: number
  private code: string
  private description: string
  private storage: string

  constructor(id: number, code: string, description: string, storage: string) {
    this.id = id
    this.code = code
    this.description = description
    this.storage = storage
  }
}

export class PositionDnet {
  public success: boolean
  public message: string
  public data?: PositionData[]

  constructor(success: boolean, message: string, data?: PositionData[]) {
    this.success = success
    this.message = message
    this.data = data
  }
}
